export default {
  title: 'Easy Air Screen',
  subtitle: 'Verwandeln Sie Ihr Tablet in einen kabellosen zweiten Monitor',
  description: 'Verwandeln Sie Ihr Tablet in ein hochwertiges kabelloses Display für macOS. Erweitern Sie Ihren Arbeitsbereich und steigern Sie die Produktivität—keine Kabel erforderlich.',
  downloadMobile: 'Mobile App Herunterladen',
  purchasePromise: 'Einmaliger Kauf. Kein Abo und keine Werbung.',
  companionPromise: 'Die Mac-App ist kostenlos und erfordert kein Konto.',
  downloadMacOS: 'Für macOS Herunterladen (Universal)',
  quickSetup: 'Schnelleinrichtung',
  setupSteps: [
    'Installieren Sie Easy Air Screen auf Ihrem Tablet',
    'Laden Sie die Desktop-App für macOS herunter und installieren Sie sie',
    'Verbinden Sie beide Geräte mit demselben Wi-Fi-Netzwerk',
    'Starten und verbinden!'
  ],
  performanceTip: 'Leistungstipp',
  performanceDescription: 'Für die beste Erfahrung mit minimaler Verzögerung verwenden Sie eine 5-GHz-Wi-Fi-Verbindung auf beiden Geräten. Wenn Sie Latenz bemerken, versuchen Sie, die Auflösung in den App-Einstellungen zu verringern.',
  faqTitle: 'Häufige Fragen',
  faq: [
    {
      q: 'Worin unterscheidet es sich von Sidecar?',
      a: 'Easy Air Screen funktioniert auch, wenn beide Geräte unterschiedliche Apple ID verwenden. Außerdem kannst du ein Android-Tablet als kabellosen Zweitbildschirm für deinen Mac nutzen.'
    },
    {
      q: 'Kann ich es mit einem Android-Tablet verwenden?',
      a: 'Ja. Du kannst ein Android-Tablet als kabellosen Zweitbildschirm für deinen Mac verwenden. Verbinde beide Geräte mit demselben Wi-Fi, um den Bildschirm zu erweitern oder zu spiegeln.'
    },
    {
      q: 'Kann ein iPhone als Zweitbildschirm dienen?',
      a: 'Ja. Ein iPhone kann als kabelloser Zweitbildschirm für deinen Mac dienen. Beim Verbinden wählst du zwischen erweitertem Schreibtisch und Bildschirmspiegelung.'
    },
    {
      q: 'Erweitert es den Bildschirm oder spiegelt es ihn?',
      a: 'Beides wird unterstützt. Du kannst den Schreibtisch deines Mac auf einen weiteren Bildschirm erweitern oder den aktuellen Bildschirm auf beiden Geräten spiegeln.'
    },
    {
      q: 'Brauche ich Internet? Gelangt mein Bildschirm nach außen?',
      a: 'Nein, eine Internetverbindung ist nicht nötig. Die Geräte verbinden sich direkt im selben Wi-Fi; dein Bildschirm wird weder über einen externen Server übertragen noch dort gespeichert.'
    },
    {
      q: 'Ist das ein Abonnement?',
      a: 'Nein. Die Geräte-App wird einmal gekauft, ist kein Abonnement und enthält keine Werbung. Die Begleit-App für Mac ist kostenlos und benötigt kein Konto.'
    },
    {
      q: 'Funktioniert es auch mit Windows-PCs?',
      a: 'Nein. Easy Air Screen ist ausschließlich für macOS ausgelegt. Windows-PCs werden derzeit nicht unterstützt.'
    },
    {
      q: 'Was kann ich tun, wenn der Bildschirm ruckelt oder langsam ist?',
      a: 'Verbinde beide Geräte nach Möglichkeit mit 5GHz Wi-Fi. Wenn weiterhin Verzögerungen auftreten, verringere die Auflösung in den App-Einstellungen.'
    },
  ]
};
